import * as insurances from './insurances'

export const IMPLEMENTATION_ALLIANZ_V1 = 'allianzV1' as const
export const IMPLEMENTATION_CSOB_V1 = 'csobV1' as const
export const IMPLEMENTATION_GENERALI_V1 = 'generaliV1' as const
export const IMPLEMENTATION_GENERTEL_V1 = 'genertelV1' as const
export const IMPLEMENTATION_KOMUNALNA_V1 = 'komunalnaV1' as const
export const IMPLEMENTATION_KOOPERATIVA_V1 = 'kooperativaV1' as const
export const IMPLEMENTATION_UNION_V2 = 'unionV2' as const
export const IMPLEMENTATION_UNIQA_V1 = 'uniqaV1' as const
export const IMPLEMENTATION_WUSTENROT_V2 = 'wustenrotV2' as const
export const ALL_IMPLEMENTATIONS = [
  IMPLEMENTATION_ALLIANZ_V1,
  IMPLEMENTATION_CSOB_V1,
  IMPLEMENTATION_GENERALI_V1,
  IMPLEMENTATION_GENERTEL_V1,
  IMPLEMENTATION_KOMUNALNA_V1,
  IMPLEMENTATION_KOOPERATIVA_V1,
  IMPLEMENTATION_UNION_V2,
  IMPLEMENTATION_UNIQA_V1,
  IMPLEMENTATION_WUSTENROT_V2,
] as const

export type Implementation = (typeof ALL_IMPLEMENTATIONS)[number]

export const INSURANCE_IMPLEMENTATIONS = {
  [insurances.INSURANCE_ALLIANZ]: [IMPLEMENTATION_ALLIANZ_V1],
  [insurances.INSURANCE_CSOB]: [IMPLEMENTATION_CSOB_V1],
  [insurances.INSURANCE_GENERALI]: [IMPLEMENTATION_GENERALI_V1],
  [insurances.INSURANCE_GENERTEL]: [IMPLEMENTATION_GENERTEL_V1],
  [insurances.INSURANCE_KOMUNALNA]: [IMPLEMENTATION_KOMUNALNA_V1],
  [insurances.INSURANCE_KOOPERATIVA]: [IMPLEMENTATION_KOOPERATIVA_V1],
  [insurances.INSURANCE_UNION]: [IMPLEMENTATION_UNION_V2],
  [insurances.INSURANCE_UNIQA]: [IMPLEMENTATION_UNIQA_V1],
  [insurances.INSURANCE_WUSTENROT]: [IMPLEMENTATION_WUSTENROT_V2],
} as const

type ReverseOf<T extends Record<string, readonly PropertyKey[]>> = {
  readonly [K in T[keyof T][number]]: {
    [I in keyof T]: K extends T[I][number] ? I : never
  }[keyof T]
}

const reverse = <T extends Record<string, readonly PropertyKey[]>>(m: T) => {
  const pairs = Object.entries(m).flatMap(([insurance, implementations]) =>
    implementations.map((implementation) => [implementation, insurance] as const),
  )
  return Object.fromEntries(pairs) as ReverseOf<T>
}

export const IMPLEMENTATION_INSURANCE = reverse(INSURANCE_IMPLEMENTATIONS)
